<template>
  <component :is="staffData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="staffData === undefined">
      <h4 class="alert-heading">獲取員工數據時出錯</h4>
      <div class="alert-body">
        找不到相關員工記錄。請查看
        <b-link class="alert-link" :to="{ name: 'staffs-list' }">
          員工名單
        </b-link>
      </div>
    </b-alert>
    <staff-edit-tab-information
      v-if="staffData"
      :gender-options="genderOptions"
      :staff-status-options="staffStatusOptions"
      :bank-options="bankOptions"
      :payment-method-status-options="paymentMethodStatusOptions"
      :staff-data="staffData"
      :role-options="roleOptions"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import staffStoreModule from "../staffStoreModule";
import StaffEditTabInformation from "./staffEditTabInformation.vue";

export default {
  components: {
    StaffEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const staffData = ref({id: 0, is_active: 0});
    const staff = {
      id: 0, is_active: 0
    };

    const Staff_APP_STORE_MODULE_NAME = "staff";

    if (!store.hasModule(Staff_APP_STORE_MODULE_NAME))
      store.registerModule(Staff_APP_STORE_MODULE_NAME, staffStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(Staff_APP_STORE_MODULE_NAME))
        store.unregisterModule(Staff_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "staff-create") {
        staffData.value = staff;
      } else {
        store
          .dispatch("staff/fetchStaff", { id: router.currentRoute.params.id })
          .then((response) => {
            staffData.value = response.data.user;
            console.log(staffData.value)
          })
          .catch((error) => {
            console.log("error when fetching staff", error);
            if (error.response.status === 404) {
              staffData.value = undefined;
            }
          });
      }
    };

    const genderOptions = ref([]);
    const staffStatusOptions = ref([]);
    const bankOptions = ref([]);
    const paymentMethodStatusOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          genders: true,
          staff_statuses: true,
          banks: true,
          payment_methods: true,
        })
        .then((response) => {
          genderOptions.value = response.data.genders;
          staffStatusOptions.value = response.data.staff_statuses;
          bankOptions.value = response.data.banks;
          paymentMethodStatusOptions.value = response.data.payment_methods;
        });
    };

    const roleOptions = ref([]);

    const fetchRoles = () => {
      store
        .dispatch("app/fetchRoles", {user_type_id: 1})
        .then((response) => {
          roleOptions.value = response.data.roles;
        });
    };

    onMounted(() => {
      refetchData();
      refetchOption();
      fetchRoles()
    });

    return {
      staffData,
      genderOptions,
      staffStatusOptions,
      bankOptions,
      paymentMethodStatusOptions,
      refetchOption,
      roleOptions
    };
  },
};
</script>
